import 'modul-bootstrap.tooltip';

import ModulTooltip from './ModulTooltip';

export {ModulTooltip};
export default ModulTooltip;

